import { FILE_TYPES } from '@shared/constants/fileTypes';
import { joinOrFormatted } from '../../../utils/arrayExtensions';
import Joi from 'joi';
import { FILE_SIZE } from '@shared/constants/fileSize';
import { getArticleForString } from '../../../utils/stringExtensions';

const FILE_TYPE_MIME_MAP = {
  [FILE_TYPES.PDF]: 'application/pdf',
  [FILE_TYPES.CSV]: 'text/csv',
  [FILE_TYPES.XLSX]: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  [FILE_TYPES.XLS]: 'application/vnd.ms-excel'
};

const FILE_TYPE_DISPLAY_MAP = {
  [FILE_TYPES.PDF]: 'PDF',
  [FILE_TYPES.CSV]: 'CSV',
  [FILE_TYPES.XLSX]: 'Excel',
  [FILE_TYPES.XLS]: 'Excel'
};

export const FileValidator = {
  createFileSchema(allowedTypes, maxSize, customTypeErrorMessage) {
    const typeErrorMessage = customTypeErrorMessage || getTypeErrorMessage(allowedTypes);
    const sizeErrorMessage = getSizeErrorMessage(maxSize);

    return Joi.object({
      type: Joi.string()
        .valid(...allowedTypes.map(type => FILE_TYPE_MIME_MAP[type]))
        .messages({
          'any.only': typeErrorMessage
        }),
      size: Joi.number().max(maxSize).messages({
        'number.max': sizeErrorMessage
      })
    });
  }
};

const getTypeErrorMessage = allowedTypes => {
  const uniqueDisplayNames = [...new Set(allowedTypes.map(type => FILE_TYPE_DISPLAY_MAP[type]))];
  const displayNamesFormated = joinOrFormatted(uniqueDisplayNames);
  const article = getArticleForString(displayNamesFormated);

  return `Please select ${article} ${displayNamesFormated} file.`;
};

const getSizeErrorMessage = maxSize => {
  const maxSizeMB = maxSize / FILE_SIZE.MB;
  return `File size limit of ${maxSizeMB} MB exceeded.`;
};

export default FileValidator;
